import ParamMaker from '@/utils/modules/ParamMaker'
import axios from '@/services/axiosConfig'

const endPoint = {
	lookupGroupTree: instId => `/institute/${instId}/group/tree`,
	lookupGroupList: instId => `/institute/${instId}/group/list`,
	lookupGroupInfo: groupId => `/group/${groupId}`,
	addGroup: instId => `/institute/${instId}/group`,
	deleteGroup: groupId => `/group/${groupId}`,
	editGroup: groupId => `/group/${groupId}`,
	lookupGroupMemberList: groupId => `/group/${groupId}/member/list`,
	addGroupMember: groupId => `/group/${groupId}/member`,
	editAccessAuthority: groupId => `/group/${groupId}/access`,
	deleteAccessAuthority: (groupId, accessId) =>
		`/group/${groupId}/access?id=${accessId}`,
	addAccessAuthority: groupId => `/group/${groupId}/access`,
	deleteGroupMember: (groupId, groupIds) =>
		`/group/${groupId}/member?${ParamMaker.setArrayString(
			'ids',
			groupIds
		)}`,
	lookupGlobalGroup: (instId, isAccessible) =>
		`/institute/${instId}/sidebar/group/tree?isAccessible=${isAccessible}`,
}

const instituteGroupAPI = {
	lookupGroupTree: instId => axios.get(endPoint.lookupGroupTree(instId)),
	lookupGroupList: instId => axios.get(endPoint.lookupGroupList(instId)),
	lookupGroupInfo: groupId => axios.get(endPoint.lookupGroupInfo(groupId)),
	addGroup: (instId, data) => axios.post(endPoint.addGroup(instId), data),
	deleteGroup: groupId => axios.delete(endPoint.deleteGroup(groupId)),
	editGroup: (groupId, data) => axios.put(endPoint.editGroup(groupId), data),
	lookupGroupMemberList: groupId =>
		axios.get(endPoint.lookupGroupMemberList(groupId)),
	addGroupMember: (groupId, data) =>
		axios.post(endPoint.addGroupMember(groupId), data),
	editAccessAuthority: (groupId, data) =>
		axios.patch(endPoint.editAccessAuthority(groupId), data),
	deleteAccessAuthority: (groupId, accessId) =>
		axios.delete(endPoint.deleteAccessAuthority(groupId, accessId)),
	addAccessAuthority: (groupId, data) =>
		axios.post(endPoint.addAccessAuthority(groupId), data),
	deleteGroupMember: (groupId, groupIds) =>
		axios.delete(endPoint.deleteGroupMember(groupId, groupIds)),
	lookupGlobalGroup: (instId, isAccessible) =>
		axios.get(endPoint.lookupGlobalGroup(instId, isAccessible)),
}

export default instituteGroupAPI
